export default __webpack_public_path__ + "static/media/gallery-wip-paint_02.c8946bee.jpg";